import SignUpContainer from './SignUpContainer';

export default SignUpContainer;



// WEBPACK FOOTER //
// ./src/components/pages/ConfirmationPage/CreateProfile/components/SignUp/index.js